import ProjectPickerPage from "../pages/home/ProjectPickerPage.vue"
import i18n from '../i18n';

const basePath = "/app/home";

const homeRoutes = [
    {
        path: basePath,
        name: "Home",
        component: ProjectPickerPage,
        meta: {
            hideNotifications: true,
            hideProjects: true,
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.Home") }
                ]
            }
        }
    },
]

export default homeRoutes